<template>
  <!--  <a-spin :spinning="isLoading">-->
  <div>
    <x-grid
        :id="'formList'"
        :rowId="rowId"
        :pager-config="pagerConfig"
        :form-config="formConfig"
        :url="url"
        :columns="columns"
        :checkbox-config="checkboxConfig"
        :toolbar-config="toolbarConfig"
        :print-config="printConfig"
        :import-config="importConfig"
        :export-config="exportConfig"
        ref="grid"
        :cellClick="chooseRow"
        :cell-db-click="updateRow"
        @toolbar-addData="addRow"
        @toolbar-delData="delRow"
        :other-params="{
          fissionId:fissionId
        }"
    >
      <template v-slot:[toolbarConfig.templatelSlots]>

      </template>
    </x-grid>


    <!--    &lt;!&ndash;明细页表单简化通用写法&ndash;&gt;-->
    <!--    <formModal title="裂变" :visible="editModalVisible">-->
    <!--      <detailForm :rowId="editRowId"-->
    <!--                  v-if="editModalVisible"-->
    <!--                  ref="detailForm"-->
    <!--                  @cancelled="closeEdit()"-->
    <!--                  @saved="closeEdit(true)">-->
    <!--      </detailForm>-->
    <!--    </formModal>-->

  </div>
  <!--  </a-spin>-->
</template>

<script>
import {
  GridMixin,
  api,
  fac,
} from "@/utils/common/XGridBase"

// import detailForm from "./detail";
import {dataApi} from "@/services/operate/marketingFission";


//列表接口 营销裂变查看客户情况列表
const url = api.operate.FISSION + '/queryCustFissionCondition';

//主键
const rowId = 'custId';

//列
const columns = [
  // fac.makeColumnRadioDefault(),
  // fac.makeColumnCheckboxDefault(),
  fac.makeColumnSeqDefault(),
  fac.makeColumn("custName", "参与客户", 200, 'center'),
  fac.makeColumn("userName", "添加员工", 200, 'center'),
  fac.makeColumn("createDate", "参与活动时间", 200, 'center'),
  // fac.makeColumn("addNum", "获奖情况", 200, 'center'),
  fac.makeColumn("parentCustName", "上级客户", 200, 'center'),
  fac.makeColumn("inviteNum", "邀请助力人数", 200, 'center'),
  fac.makeColumn("isDeleteName", "是否流失", 200, 'center',true),
]

//筛选项
const formConfig = fac.makeFormConfig(columns, [
  {field: 'custName'},
  {field: 'userName'},
  {field: 'createDate', type: 'dateRange'},
])

//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  import: false,
  export: false,
  delData: false,
  addData: false,
  templatelSlots: 'toolbarBtns'
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);

async function loadBaseData() {

}

export default {
  mixins: [GridMixin],
  components: {
    // detailForm,
  },
  props:['fissionId'],
  data() {
    return {
      columns,
      rowId,
      url,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,
      prizeModalVisible: false,
      publistModalVisible: false,
      // fissionId: this.$route.query.id ? this.$route.query.id : 1,
      tagIds: ''
    }
  },
  async mounted() {
  },
  methods: {
    loadBaseData,
    async setOpen() {
      let row = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
      this.loading(true);
      await dataApi.updateIsUse(row[0][this.rowId]).then(() => {
        this.$message.success('启用成功');
        this.loading(false);
      }).catch(() => {
        this.loading(false);
      });
      this.refresh()
    },
  }
}
</script>

<style scoped>
</style>
